import { AxiosResponse } from 'axios';
import { TypeDoc } from 'shell/models/type-doc';
import { TypeDocResponse, TypeDocClient } from 'front-office/view-models/type-doc-list';
import { HttpResponseList } from 'shell/models/http-response';
import { typeRights } from '../shared/type-rights-list';

export const transformeTypeDocList = (
  response: AxiosResponse<HttpResponseList<TypeDoc>>
): TypeDocResponse => {
  const data: Array<TypeDoc> = response.data.payload?.list || [];

  const resList: Array<TypeDocClient> = data.map((item: TypeDoc) => {
    const typeDoc = item.raggruppamentoCertificati?.descrizioneTipoDocumento || '';

    const typeRight = typeRights.find((type) => type.id === item.tipoDiritti)?.value || '';

    return {
      code: item.key?.codiceDocumento || '',
      description: item.descrizioneTipoDocumento || '',
      typeDoc,
      codeTypeDoc: item.key?.tipoDocumento || '',
      typeRights: typeRight,
      mode: item?.dettaglioModalitaRilascio?.descrizione || '', // TODO estrarre la descrizione
    };
  });

  return {
    count: response.data.payload?.totalRows || 0,
    list: resList,
  } as TypeDocResponse;
};
